import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Box, CircularProgress, useTheme } from "@mui/material";
import api from "services/api";
import InterpretationProfile from "./interpretations/InterpretationProfile";
import TranslationProfile from "./translations/TranslationProfile";
import OtherServiceProfile from "./other/OtherServiceProfile";

/**
 * ServiceProfile - Routes to the correct service type profile component
 * based on the ServiceCategory of the service
 */
const ServiceProfile = () => {
  const { id } = useParams();
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [serviceCategory, setServiceCategory] = useState(null);
  const [error, setError] = useState(false);
  
  useEffect(() => {
    const fetchServiceCategory = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/services/${id}`);
        if (response?.data?.serviceCategory) {
          setServiceCategory(response.data.serviceCategory);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Error fetching service category:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchServiceCategory();
    }
  }, [id]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        bgcolor={theme.palette.background.default}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error || !serviceCategory) {
    return <Navigate to="/services" replace />;
  }

  // Route to the appropriate service type profile
  switch (serviceCategory) {
    case "Interpretation":
      return <InterpretationProfile />;
    case "Translation":
      return <TranslationProfile />;
    case "Other":
      return <OtherServiceProfile />;
    default:
      return <Navigate to="/services" replace />;
  }
};

export default ServiceProfile;
